import { Img } from 'Components/Image/Img'
import { EventHubExperience } from '../../../../Api'
import { ExperienceItemCon } from '../styles'
import { colors } from 'Components/consts'
import { Head3 } from 'Components/Typography/Text.styles'
import { PLL_IMAGES } from 'Config/config'

type ExperienceItemParams = {
  experience: EventHubExperience
  onExperienceSelected: (experience: EventHubExperience) => void
  index: number
}

export const ExperienceItem: React.FC<ExperienceItemParams> = ({
  experience,
  onExperienceSelected,
  index,
}) => {
  return (
    <ExperienceItemCon>
      <Img
        src={experience.previewImg || PLL_IMAGES.pllAppLogo}
        alt={experience.title || `Event Experience - ${index}`}
      />
      <div className="experience-item-content">
        <Head3 color={colors.white}>{experience.title}</Head3>
        <div onClick={() => onExperienceSelected(experience)} className="button">
          Learn More
        </div>
      </div>
    </ExperienceItemCon>
  )
}
